export const ExerciseOptions = {
    other: 'Other',
    steps: 'Steps',
    running_outdoor: 'Running Outdoor',
    running_indoor: 'Running Indoor',
    walking_outdoor: 'Walking Outdoor',
    walking_indoor: 'Walking Indoor',
    cycling_outdoor: 'Cycling Outdoor',
    cycling_indoor: 'Cycling Indoor',
    swimming: 'Swimming',
    rowing: 'Rowing',
    elliptical: 'Elliptical',
    skiing: 'Skiing',
    wheelchair: 'Wheelchair',
};
export const DATE_PICKER_FORMAT = 'do MMM yyyy';
export const DATE_DATABASE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DATABASE_NOT_LANCHED = '0000-00-00 00:00:00';
export var CHALLENGE_CATEGORIES;
(function (CHALLENGE_CATEGORIES) {
    CHALLENGE_CATEGORIES[CHALLENGE_CATEGORIES["CONQ_ID"] = 1] = "CONQ_ID";
    CHALLENGE_CATEGORIES[CHALLENGE_CATEGORIES["LOTR_ID"] = 2] = "LOTR_ID";
    CHALLENGE_CATEGORIES[CHALLENGE_CATEGORIES["ROTK_ID"] = 3] = "ROTK_ID";
})(CHALLENGE_CATEGORIES || (CHALLENGE_CATEGORIES = {}));
export var MAP_TYPE;
(function (MAP_TYPE) {
    MAP_TYPE[MAP_TYPE["NOMAP"] = 0] = "NOMAP";
    MAP_TYPE[MAP_TYPE["GOOGLE_MAPS"] = 1] = "GOOGLE_MAPS";
    MAP_TYPE[MAP_TYPE["MAPBOX"] = 2] = "MAPBOX";
    MAP_TYPE[MAP_TYPE["SKIA"] = 3] = "SKIA";
    MAP_TYPE[MAP_TYPE["LEGACY"] = 99] = "LEGACY";
})(MAP_TYPE || (MAP_TYPE = {}));
